import { render, staticRenderFns } from "./ProjectBiometricDetails.vue?vue&type=template&id=d03d00f6&"
import script from "./ProjectBiometricDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectBiometricDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports